import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { SelectProductEffects } from './select-product.effects';
import { ISelectProductFeature } from './select-product.feature.state';
import { selectProductReducer } from './select-product.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ISelectProductFeature>('selectProduct'), selectProductReducer),
    EffectsModule.forFeature([SelectProductEffects]),
  ],
})
export class SelectProductStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: SelectProductStateModule
  ) {
    if (parentModule) {
      throw new Error('SelectProductStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
